import { useEffect, useState } from 'react';

export const useTelegramWebApp = () => {
    const [isTelegram, setIsTelegram] = useState(false);
    const [webApp, setWebApp] = useState<any>(null);

    useEffect(() => {
        if (typeof window !== 'undefined' && (window as any).Telegram && (window as any).Telegram.WebApp) {
            const twa = (window as any).Telegram.WebApp;
            
            // We assume it's Telegram if initData is present or platform is not unknown
            if (twa.initData || (twa.platform && twa.platform !== 'unknown')) {
                setIsTelegram(true);
                setWebApp(twa);
                
                // Notify Telegram that the UI is fully loaded 
                twa.ready();
                
                // Ensure Miniapp is maximized vertically
                if (twa.expand) {
                    twa.expand();
                }

                // Make the app root styling match Telegram guidelines
                document.body.style.backgroundColor = 'var(--tg-theme-bg-color, #131722)';
                document.body.style.color = 'var(--tg-theme-text-color, #d1d4dc)';
            }
        }
    }, []);

    return { isTelegram, webApp };
};
